import {Fragment} from "react";
import Markets from "./Markets";
import wallets from '../../img/wallets.png';
import {NavLink} from "react-router-dom";
const Index = (props) => {


    return (

        <Fragment>


            <div className="container-xl position-relative">
                <div className="row py-5">
                    <div className="col-auto ps-0">
                        <div className="avatar avatar-lg rounded-circle mt-2"><img alt="بیت کوین"
                                                                                   src={props.ctx.btn['USDT']}/>
                        </div>
                    </div>
                    <div className="col"><span className="h2 bolder text-dark2 d-block mb-0">تتهر </span>
                        <div className="text-end" dir="ltr"><span
                            className="font-light mb-0 en text-lg text-muted"> Tether </span></div>
                    </div>
                </div>
                <div className="row g-5 py-10 pt-0 mb-10 align-items-center">
                    <div className="col-lg-9 mb-10 mb-lg-0"><h1
                        className="ls-tighter mb-5 superbold text-transparent bg-clip-text gradient-bottom-right start-blue-400 end-purple-500 position-relative d-block">
                        <span className="lh-tight ls-tighter display-4"> ارز تتهر چیست + چگونه بخریم + چگونه بفروشیم </span>
                    </h1><h2 className="ls-tighter superbold"><span className="lh-normal mt-2 d-block leadsubtext"> خرید و فروش ارز دیجیتال به ساده‌ترین شکل ممکن را می‌توانید با ما تجربه نمایید. </span>
                    </h2>


                        <div className="text-md lh-normal font-regular ps-lg-24 pb-3 text-justify">
                            <span
                            className="text-muted lh-35">
                                <strong> صرافی ارزدیجیتال با بهره‌گیری از ساده‌ترین روش‌ها، شما را برای رسیدن به آنچکه نیاز دارید همراهی می‌کند. </strong>
                                <br /> جهت آشنایی با روال کلی کار با وب سایت صرافی و نحوه ثبت سفارش خرید و سفارش فروش می‌توانید به قسمت

                                  مراجعه نمایید. همچنین باتوجه به فعال بودن مارکت‌های ارز بیت کوین همین حالا می‌توانید
                                <NavLink
                            to={window.config.staticAddress+"/trades/USDT"}>سفارش خرید یا فروش</NavLink> خود را ثبت نمایید. </span></div>
                    </div>
                    <div className="col-lg-3 d-none d-lg-block">
                        <div className="position-relative"><img src= {wallets} alt="درباره ارز بیت کوین" /></div>
                    </div>
                    {props.auth === null && <div className="col-12">
                        <div className="mx-md-n2 text-center"><NavLink
                            to={window.config.staticAddress + "/auth/register"}
                            className="btn btn-primary px-6 py-3 font-bold my-2 mx-md-2 w-full w-md-auto transform scale-105-hover transition ease-in">
                            <i className="far fa-user-plus ms-3 opacity-50"></i>ثبت‌ نام و خرید ارز دیجیتال </NavLink>
                            <NavLink
                                to={window.config.staticAddress + "/auth/login"}
                                className="btn btn-outline-dark px-6 py-3 font-bold my-2 mx-md-2 w-full w-md-auto transform scale-105-hover transition ease-in"> ورود
                                به صرافی <i className="far fa-arrow-left me-3 opacity-50"></i> </NavLink></div>
                    </div>}
                </div>
            </div>


            <Markets setTraid={props.setTraid} traid={props.traid} logo={props.logo} trs={props.trs}/>
        </Fragment>
)
}
export default Index;
